// Centralized control for Apply entry behavior


const handleApplyEntry = ({
  show,
  history,
  openApplySidebar
}) => {
  if (!show || !history) {
    console.warn("handleApplyEntry: missing show or history");
    return;
  }

  const IsGermanShoreShow =
    process.env.REACT_APP_IS_GERMAN_SHORE_SHOW === 'true';

  if (IsGermanShoreShow) {
    history.push("/apply/consent");
    return;
  }
  if (typeof openApplySidebar === "function") {
    openApplySidebar();
  } else {
    history.push("/apply");
  }
};

export default handleApplyEntry;



// WEBPACK FOOTER //
// ./src/components/common/handleApplyEntry.js